// ===========================
// summary.rows.js (new file)
// ===========================
import React from "react";

export default function SummaryRows({ rows = [] }) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return (
      <tr>
        <td colSpan={11} style={{ textAlign: "center" }}>
          No Data
        </td>
      </tr>
    );
  }

  return (
    <>
      {rows.map((r, i) => {
        const name = r?.full_name || "-";
        const photoUrl = r?.photo || "";
        const avatar = photoUrl ? (
          <div
            className="image-circle"
            style={{
              background: `url('${photoUrl}') no-repeat center`,
              backgroundSize: "cover" }}
          />
        ) : (
          <div className="image-circle">
            <i className="material-icons" style={{ marginLeft: "0px" }}>
              person
            </i>
          </div>
        );

        return (
          <tr key={r?.idu || i}>
            <td
              className="td-photo"
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              {avatar}
            </td>
            <td>
              <div>{name}</div>
              <div className="small-text">
                ({r?.country_name || r?.country_code || ""})
              </div>
            </td>
            <td>{r?.annual_leave_days ?? 0}</td>
            <td>{r?.last_year_balance ?? 0}</td>
            <td>{r?.current_year_balance ?? 0}</td>
            <td>
              <div className="red-text text-darken-1">
                {r?.leave_days_taken ?? 0}
              </div>
            </td>
            <td>{r?.leave_days_expired ?? 0}</td>
            <td className="green-text text-darken-1">
              {r?.leave_days_balance ?? 0}
            </td>
            <td className="blue-text text-darken-1">
              {r?.compensatory_leave_balance ?? 0}
            </td>
            <td>{r?.compensatory_leave_used ?? 0}</td>
            <td>{r?.sick_leave_used ?? 0}</td>
          </tr>
        );
      })}
    </>
  );
}

